import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { EditBulkActionRules } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/EditBulkActionRulesPage/EditBulkActionRules/EditBulkActionRules';
import { EditBulkTagsRules } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/EditBulkActionRulesPage/EditBulkTagsRules/EditBulkTagsRules';
import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';
import { TreeProgramTopHeader } from 'components/common';

export const EditBulkActionRulesPage = () => {
    useFullStoryPageView({ pageName: executionConfig.editBulkActionRules.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <TreeProgramTopHeader versionSelectorEnabled={false} isDisabled={true} />
                <BottomHeaderSection>
                    <ProgramTopHeader
                        pageTitle={executionConfig.editBulkActionRules.title}
                        showBack={true}
                    ></ProgramTopHeader>
                </BottomHeaderSection>
            </HeaderWrapper>

            <MainContent>
                <EditBulkActionRules />
                <EditBulkTagsRules />
            </MainContent>
        </PageContainer>
    );
};
